import { RouteConfig } from 'vue-router';
const TemList = () => import('./views/tem-list.vue');
const TemEdit = () => import('./views/tem-edit.vue');
const GroupFolder = () => import('./views/group-folder.vue');
const GroupPreview = () => import('./views/group-preview.vue');
const PlanFolder = () => import('./views/plan-folder.vue');
const PlanPreview = () => import('./views/group-preview.vue');
const routers: RouteConfig[] = [
    {
        path: 'tem-list',
        name: 'tem-list',
        component: TemList
    },
    {
        path: 'tem-edit',
        name: 'tem-edit',
        component: TemEdit
    },
    {
        path: 'group-folder',
        name: 'group-folder',
        component: GroupFolder
    },
    {
        path: 'group-preview',
        name: 'group-preview',
        component: GroupPreview
    },
    {
        path: 'plan-folder',
        name: 'plan-folder',
        component: PlanFolder
    },
    {
        path: 'plan-preview',
        name: 'plan-preview',
        component: PlanPreview
    },
    {
        path: '',
        redirect: 'tem-list'
    },
];
export default routers;

